import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EmailVerification } from 'projects/login/src/app/pages/email-verification/models/email-verify.model';
import { environment } from '../../../environments/environment';
import { AuthPasswordRecoverRequest } from './models/auth-password-recover-request';
import { AuthSetPasswordRequest } from './models/auth-set-password-request';
import { AuthSetPasswordResponse } from './models/auth-set-password-response';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  private readonly _httpClient = inject(HttpClient);

  basePath: string = environment.authUrl + '/v2/accounts';

  passwordRecover(passwordRecoverRequest: AuthPasswordRecoverRequest) {
    return this._httpClient.post(`${this.basePath}/password-recover`, passwordRecoverRequest);
  }

  setPassword(setPasswordRequest: AuthSetPasswordRequest) {
    return this._httpClient.patch<AuthSetPasswordResponse>(`${this.basePath}/password`, setPasswordRequest);
  }

  verifyEmail(verificationModel: EmailVerification, accountCode: string) {
    return this._httpClient.post(`${this.basePath}/${accountCode}/email-verify`, verificationModel);
  }
}
